import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary, ToastProvider } from "@ds";
import { AppShell } from "./components/AppShell";
import { PageLoading } from "./components/PageLoading";

const HomePage = lazy(() => import("./pages/Home"));
const ProductsPage = lazy(() => import("./pages/Products"));
const ProductDetailPage = lazy(() => import("./pages/ProductDetail"));
const AboutPage = lazy(() => import("./pages/About"));
const FaqPage = lazy(() => import("./pages/Faq"));
const ContactPage = lazy(() => import("./pages/Contact"));
const TermsPage = lazy(() => import("./pages/legal/Terms"));
const PrivacyPage = lazy(() => import("./pages/legal/Privacy"));
const LicensePage = lazy(() => import("./pages/legal/License"));
const CookiesPage = lazy(() => import("./pages/legal/Cookies"));
const ImprintPage = lazy(() => import("./pages/legal/Imprint"));
const RefundPage = lazy(() => import("./pages/legal/Refund"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const NotFoundPage = lazy(() => import("./pages/NotFound"));

export function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route
                index
                element={
                  <Suspense fallback={<PageLoading />}>
                    <HomePage />
                  </Suspense>
                }
              />
              <Route
                path="products"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ProductsPage />
                  </Suspense>
                }
              />
              <Route
                path="products/buildyourrack"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ProductDetailPage productId="byr" />
                  </Suspense>
                }
              />
              <Route
                path="products/logicdmx"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ProductDetailPage productId="logicdmx" />
                  </Suspense>
                }
              />
              <Route
                path="products/phase"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ProductDetailPage productId="phase" />
                  </Suspense>
                }
              />
              <Route
                path="products/st4sh"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ProductDetailPage productId="stash" />
                  </Suspense>
                }
              />
              <Route
                path="pricing"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <PricingPage />
                  </Suspense>
                }
              />
              <Route
                path="products/st4sh/pricing"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <PricingPage />
                  </Suspense>
                }
              />
              <Route
                path="about"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <AboutPage />
                  </Suspense>
                }
              />
              <Route
                path="faq"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <FaqPage />
                  </Suspense>
                }
              />
              <Route
                path="contact"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <ContactPage />
                  </Suspense>
                }
              />
              <Route path="legal">
                <Route
                  path="terms"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <TermsPage />
                    </Suspense>
                  }
                />
                <Route
                  path="privacy"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <PrivacyPage />
                    </Suspense>
                  }
                />
                <Route
                  path="refunds"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <RefundPage />
                    </Suspense>
                  }
                />
                <Route
                  path="license"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <LicensePage />
                    </Suspense>
                  }
                />
                <Route
                  path="cookies"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <CookiesPage />
                    </Suspense>
                  }
                />
                <Route
                  path="imprint"
                  element={
                    <Suspense fallback={<PageLoading />}>
                      <ImprintPage />
                    </Suspense>
                  }
                />
              </Route>
              <Route
                path="*"
                element={
                  <Suspense fallback={<PageLoading />}>
                    <NotFoundPage />
                  </Suspense>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  );
}
